module.exports = __webpack_public_path__ + "static/img/hussar_select_face.de8c5e6.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/documentPage/hussar_select_face.webp
// module id = FKnB
// module chunks = 0